import classNames from 'classnames'
import styles from './styles.module.scss'

export type OptionWithIconProps<T extends string> = {
  onSelect: (optionValue: T) => void
  active: boolean
  optionValue: T
  description?: string
  classes?: string
  iconClasses?: string
  selected?: boolean
  variant?: 'horizontal' | 'vertical'
  icon: React.ElementType | undefined
}

function OptionWithIcon<T extends string>({
  variant = 'horizontal',
  optionValue,
  description,
  onSelect,
  selected = false,
  active,
  classes = '',
  iconClasses = '',
  icon: Icon,
  ...props
}: OptionWithIconProps<T>) {
  const optionClasses = classNames(
    styles.OptionWithIcon,
    styles[`variant_${variant}`],
    {
      [styles.selected]: selected,
      [styles.active]: active,
      [styles.outOfStockSizeSelector]: !active
    },
    classes
  )

  const optionIconClasses = classNames(
    {
      [styles.OptionWithIcon__icon_selected]: selected,
      [styles.OptionWithIcon__icon_active]: !active
    },
    iconClasses
  )

  return (
    <button
      className={optionClasses}
      type="button"
      onClick={() => {
        onSelect(optionValue)
      }}
      {...props}
    >
      <div>
        <p className={styles.OptionWithIcon__type}>{optionValue}</p>
        {description && (
          <p className={styles.OptionWithIcon__description}>{description}</p>
        )}
      </div>
      {Icon && (
        <div className={styles.OptionWithIcon__icon}>
          <Icon className={optionIconClasses} />
        </div>
      )}
    </button>
  )
}

export default OptionWithIcon
